import React from "react";
 import { Link } from "react-router-dom";
 import { Navigate } from "react-router-dom";
 import LoginService from '../service/Loginservice';
 import Store from '../reduxdata/Store'
 import {ACTION_LOGIN} from '../reduxdata/actions/UserAction'
export default class Login extends React.Component {
    constructor(){
        super()
        this.state={
            msg:'',
            islogin:false,
            logintype:''
        }
    }
    login = (event)=>{
     this.setState({msg:"Sign In"})
        var ob = {
            email:this.emailbox.value,
            password:this.passbox.value,
            type:this.typebox.value
        }
        var pro=LoginService.login(ob)
        pro.then(response=>response.json())
        .then(data=>{
            if(data.status){
                Store.dispatch({
                    ...ACTION_LOGIN,payload:{
                        userId:this.typebox.value=='Candidate'?data.data.id:data.data.id,
                        userName:data.data.name,
                        type:this.typebox.value
                        
                    }
                })
                this.setState({msg:'',islogin:true,logintype:this.typebox.value})
            }
            else
            this.setState({msg:"Login Failed !"})
        })
        .catch(err=>{
            console.log(err)
        })
        event.preventDefault()
    }
    render()
{ if(this.state.islogin){
    if(this.state.logintype=="Admin")
    return <Navigate to="/"/>
    if(this.state.logintype=="User")
    return<Navigate to="/"/>

}
        return<div>
          <br/>
        <div>
           <div className="container-fluid bg-dark kpy-5 mb-5">
        <div className="container py-5">
            <div className="row align-items-center py-4">
                <div className="col-md-6 text-center text-md-left">
                    <h1 className="display-4 mb-4 mb-md-0 text-secondary text-uppercase">LOGIN</h1>
                </div>
             </div>
         </div>
      </div>
    </div>

<div className="row">
<div className="col-lg-7 mb-5 mb-lg-0" >
    <div className="contact-form" >
        <div id="success"></div>
        <form name="sentMessage" novalidate="novalidate" id="newsletterForm" onSubmit={this.login}>
            <div className="form-row">  
                
                
                <div className="col-sm-6 control-group" style={{textAlign:"center"}}>
                    <input type="email" className="form-control p-4" id="email" placeholder="Your Email" ref={c=>this.emailbox=c}required="required" data-validation-required-message="Please enter your email" />
                    <p className="help-block text-danger"></p>
                </div>
              </div>
                <div className="col-sm-6 control-group" style={{textAlign:"center"}}>
                    <input type="number" className="form-control p-4" id="password" placeholder="Your Password" ref={c=>this.passbox=c} required="required" data-validation-required-message="Please enter your Password" />
                    <p className="help-block text-danger"></p>
                </div>
                <div>
                    <select ref={c=>this.typebox=c} >
                        <option value=''>Login Type</option>
                        <option >Admin</option>
                        <option >User</option>
                      
                    </select>
                </div>
            
            <div>
           <button className="btn btn-primary btn-block py-3 px-5" type="submit" id="sendMessageButton">LOGIN</button>
           <b className="text-danger">{this.state.msg}</b>
            </div>
            <div className="forgot-password">
        <div>
     <Link to=""> <h6 style={{ color: 'red' }}>FORGOT-PASSWORD</h6></Link>
     <Link to="/Registration"> <h6 style={{ color: 'green' }}>CREATE-ACCOUNT</h6></Link>
    </div>
      </div>
        </form>
    </div>
</div>
</div>
</div>
    }
}